import { ApiError } from "@/lib/api";

/** Reads the `code` off a standard error body (`{ code, ... }`), if present. */
export function errorCode(err: unknown): string | null {
  if (err instanceof ApiError && !!err.body && typeof err.body === "object" && "code" in err.body) {
    const code = (err.body as { code?: unknown }).code;
    return typeof code === "string" ? code : null;
  }
  return null;
}

/** Reads a string field off an error body (e.g. `hostedInvoiceUrl`), if present. */
export function errorField(err: unknown, field: string): string | null {
  if (err instanceof ApiError && !!err.body && typeof err.body === "object") {
    const value = (err.body as Record<string, unknown>)[field];
    return typeof value === "string" ? value : null;
  }
  return null;
}
